/* eslint-disable react/jsx-indent */
import React, { useState, useCallback , useEffect} from 'react'
import moment from 'moment'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../../components/Modal/Modal'

import InputError from '../../../components/InputError/InputError'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoInput from '../../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'
import AccountDisplay from '../../../components/account-display/account-display'
import {
  getAccountListSelector,
  getCurrentAccDetailsSelector,
} from '../../../store/selectors/app.selector'
import { StopChequePaymentSchema } from '../../../schemas/requests'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import RequestService from '../../../services/request.service'
import { BUTTON_KEYS, STOP_CHEQUE_KEYS } from './../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
const stopChequeConfig = validationConfig['OtherService']['stopCheque']

function StopChequePayment() {
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [otp, setOtp] = useState('')
  const history = useHistory()
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [verifyDetails, setVerifyDetails] = useState({})
  const [otpEnabled, setOtpEnabled] = useState(false)
  const {t}=useTranslation()
  const [formValues, setFormValues] = useState({
    rangeOfCheques: 'INDIVIDUAL',
    accountNumber: '',
    chequeNumber: '',
    reason: '',
    effectiveDate: '',
    startChequeNumber: '',
    endChequeNumber: '',
    remarks: '',
  })
  const [reasonList, setReasonList]=useState([])
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{message?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(()=>{
    getStopChequeReasonList()
  },[])

  const getStopChequeReasonList=useCallback(async()=>{
    try{
      setLoading(true)
      const response=await RequestService.getStopChequeReasonList()
      if(response.status===200){
        setReasonList(response.data["stopChequeReason"])
        setLoading(false)
      }
    }catch(err){
      setLoading(false)
    }
  },[])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={confirmStopChequeBook} />
        )
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm()
    }
  }

  const submitStopChequePaymentForm = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true)
        setFormValues(data)

        const response =
          data.rangeOfCheques === 'INDIVIDUAL'
            ? await RequestService.verifyStopCheque({
                accountNo: currentAccountDetail?.accountNo,
                endChequeNumber: data.chequeNumber,
                startChequeNumber: data.chequeNumber,
                effectiveDate: data.effectiveDate,
                reason: data.reason,
                requestType: 'Individual Cheque',
                branchCode: currentAccountDetail?.brnCode,
                remarks: data.remarks,
              })
            : await RequestService.verifyStopCheque({
                accountNo: currentAccountDetail?.accountNo,
                endChequeNumber: data.endChequeNumber,
                startChequeNumber: data.startChequeNumber,
                effectiveDate: data.effectiveDate,
                reason: data.reason,
                requestType: 'Range Of Cheques',
                branchCode: currentAccountDetail?.brnCode,
                remarks: data.remarks,
              })
        if (response.status === 200) {
          setSubmitting(false)
          setVerifyDetails(response.data)
          setOtpEnabled(response.data['otpEnable'])

          setLoading(false)
          setStage(2)
          return
        }
      } catch (err) {
        setMessage(err.data.message)
        setSubmitting(false)
        //showModal()
      }
    },
    [showModal, currentAccountDetail],
  )

  const confirmStopChequeBook = useCallback(async () => {
    try {
      setLoading(true)
      const response =
        formValues.rangeOfCheques === 'INDIVIDUAL'
          ? await RequestService.stopChequeConfirm({
              accNo: currentAccountDetail?.accountNo,
              endChequeNo: formValues.chequeNumber,
              startChequeNo: formValues.chequeNumber,
              effectiveDate: formValues.effectiveDate,
              reason: formValues.reason,
              otp: otp || '0000',
              stopPaymentType: 'Individual Cheque',
              branchCode: currentAccountDetail?.brnCode,
              remarks: formValues.remarks,
              randomKey: verifyDetails.randomKey,
            })
          : await RequestService.stopChequeConfirm({
              accNo: currentAccountDetail?.accountNo,
              endChequeNo: formValues.endChequeNumber,
              startChequeNo: formValues.startChequeNumber,
              effectiveDate: formValues.effectiveDate,
              reason: formValues.reason,
              stopPaymentType: 'Range Of Cheques',
              branchCode: currentAccountDetail?.brnCode,
              remarks: formValues.remarks,
              otp: otp || '0000',
              randomKey: verifyDetails.randomKey,
            })
      if (response.status === 200) {
        setMessage(response.data['message'])
        setStage(4)
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setMessage(err.data.message)
      setOtp('')
      //showModal()
    }
  }, [formValues, otp, showModal, currentAccountDetail, verifyDetails])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(STOP_CHEQUE_KEYS.TITLE)}</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          validationSchema={StopChequePaymentSchema}
          onSubmit={submitStopChequePaymentForm}>
          {({ isSubmitting, values, resetForm, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group my-2'>
                <div className='row justify-content-center mb-3'>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      as='input'
                      type='radio'
                      id='individualCheque'
                      name='rangeOfCheques'
                      value='INDIVIDUAL'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='individualCheque'>
                      {t(STOP_CHEQUE_KEYS.INDIVIUAL_CHEQUE)}
                    </label>
                  </div>
                  <div className='custom-control custom-radio custom-control-inline'>
                    <Field
                      as='input'
                      value='RANGE'
                      type='radio'
                      id='isChequeRange'
                      name='rangeOfCheques'
                      className='custom-control-input'
                      onClick={resetForm}
                      disabled={isSubmitting}
                    />
                    <label className='custom-control-label' htmlFor='isChequeRange'>
                      {t(STOP_CHEQUE_KEYS.RANGE_OF_CHEQUE)}
                    </label>
                  </div>
                </div>
                <div className='row'>
                  {values.rangeOfCheques === 'INDIVIDUAL' ? (
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        showAsterisk={stopChequeConfig['isChequeNumberRequired']}
                        disabled={isSubmitting}
                        text={t(STOP_CHEQUE_KEYS.CHEQUE_NO)}
                        onChange={handleChange}
                        name='chequeNumber'
                        value={values.chequeNumber}
                      />
                      <InputError text={errors.chequeNumber} touched={touched.chequeNumber} />
                    </div>
                  ) : (
                    <>
                      <div className='form-group col-12'>
                        <NeoInput
                          tabIndex='1'
                          showAsterisk={stopChequeConfig['isStartChequeNoRequired']}
                          text={t(STOP_CHEQUE_KEYS.START_CHEQUE_NO)}
                          onChange={handleChange}
                          name='startChequeNumber'
                          disabled={isSubmitting}
                          value={values.startChequeNumber}
                        />
                        <InputError
                          text={errors.startChequeNumber}
                          touched={touched.startChequeNumber}
                        />
                      </div>
                      <div className='form-group col-12'>
                        <NeoInput
                          tabIndex='2'
                          showAsterisk={stopChequeConfig['isEndChequeNoRequired']}
                          text={t(STOP_CHEQUE_KEYS.END_CHEQUE_NO)}
                          onChange={handleChange}
                          name='endChequeNumber'
                          disabled={isSubmitting}
                          value={values.endChequeNumber}
                        />
                        <InputError
                          text={errors.endChequeNumber}
                          touched={touched.endChequeNumber}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    <label>
                      {t(STOP_CHEQUE_KEYS.REASON)}
                      {stopChequeConfig['isReasonRequired'] ? '*' : ''}
                    </label>
                    <Field
                      tabIndex={'3'}
                      showAsterisk={stopChequeConfig['isReasonRequired']}
                      as='select'
                      name='reason'
                      onChange={handleChange}
                      className='form-control'>
                      <option value='' disabled defaultValue />
                      {reasonList.map((opt, i) => (
                        <option value={opt} key={i}>
                          {opt}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.reason} touched={touched.reason} />
                  </div>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={stopChequeConfig['isEffectiveDateRequired']}
                      text={t(STOP_CHEQUE_KEYS.EFFECTIVE_DATE)}
                      name='effectiveDate'
                      type='date'
                      onChange={handleChange}
                      min={moment(new Date()).format('YYYY-MM-DD')}
                      disabled={isSubmitting}
                      value={values.effectiveDate}
                    />
                    <InputError text={errors.effectiveDate} touched={touched.effectiveDate} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={stopChequeConfig['isRemarksRequired']}
                      disabled={isSubmitting}
                      text={t(STOP_CHEQUE_KEYS.REMARKS)}
                      onChange={handleChange}
                      name='remarks'
                      value={values.remarks}
                      minLength={2}
                      maxLength={40}
                      onKeyPress={(event) => {
                        if (
                          !(event.charCode >= 65 && event.charCode <= 90) &&
                          !(event.charCode >= 97 && event.charCode <= 122) &&
                          event.charCode !== 32
                        ) {
                          event.preventDefault()
                        }
                      }}
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {isSubmitting ? (
                      renderLoading()
                    ) : (
                      <NeoButton
                        tabIndex='6'
                        mode='newDesign'
                        type='submit'
                        disabled={isSubmitting}
                        text={t(BUTTON_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                <button tabIndex={'7'} className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => history.goBack()}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(STOP_CHEQUE_KEYS.CONFIRM_TITLE)}</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />

        {formValues.rangeOfCheques === 'INDIVIDUAL' ? (
          <div>
            <h6 className='label'>{t(STOP_CHEQUE_KEYS.CHEQUE_NO)}</h6>
            <h6 className='value'>{formValues.chequeNumber}</h6>
          </div>
        ) : (
          <>
            <div>
              <h6 className='label'>{t(STOP_CHEQUE_KEYS.START_CHEQUE_NO)}</h6>
              <h6 className='value'>{formValues.startChequeNumber}</h6>
            </div>
            <div>
              <h6 className='label'>{t(STOP_CHEQUE_KEYS.END_CHEQUE_NO)}</h6>
              <h6 className='value'>{formValues.endChequeNumber}</h6>
            </div>
          </>
        )}
        <div>
          <h6 className='label'>{t(STOP_CHEQUE_KEYS.REASON)}</h6>
          <h6 className='value'>{formValues.reason}</h6>
        </div>
        <div>
          <h6 className='label'>{t(STOP_CHEQUE_KEYS.EFFECTIVE_DATE)}</h6>
          <h6 className='value'>{moment(formValues.effectiveDate).format('DD-MM-YYYY')}</h6>
        </div>
        <div>
          <h6 className='label'>{t(STOP_CHEQUE_KEYS.REMARKS)}</h6>
          <h6 className='value'>{formValues.remarks || '-'}</h6>
        </div>

        <div>
          <TermsAndCondition module='STOPCHEQUEPAYMENT' />
        </div>

        <div className='mt-5'>
          <NeoButton
            mode='newDesign'
            type='button'
            text={t(BUTTON_KEYS.CONFIRM)}
            onClick={() => (otpEnabled ? setStage(3) : confirmStopChequeBook())}
          />
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    )
  }

  // const stageCallback = useCallback(() => {
  //   const startStage = 1
  //   if (stage === startStage) {
  //     history.goBack()
  //   } else if (startStage) {
  //     const newStage = stage - 1
  //     setStage(newStage)
  //   }
  // }, [stage])

  // function renderBackButton() {
  //   return (
  //     <div
  //       className='mx-2 mb-4 cursor-pointer font-weight-600'
  //       style={{ fontSize: 12, width: 'fit-content' }}
  //       onClick={stageCallback}>
  //       <img className='mr-4' src={BackArrow} />
  //       Back to Cheque Options
  //     </div>
  //   )
  // }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_STOP_CHEQUE'>
      {/* <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={menuDetails.icon} alt='statement icon' />
          </div>
          <div>
            <span className='font-weight-bold'>{menuDetails.title}</span>
            <span className='header-title-section'>
              <p>{menuDetails.desc}</p>
            </span>
          </div>
        </div>
        <div className='col-5 text-right'></div>
      </div>
      {stage !== 4 && stage !== 3 && renderBackButton()} */}
      <div className='new-design-form-style'> {renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}

export default StopChequePayment
